<template>
    <div class="limit-tag-container" ref="limit-tag" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <div class="limit-tag">
            <Icon :icon-name="limitReached ? 'lock' : 'ai-sparkling-icon'" />
            <div class="limit-text">
                {{ limitReached ? 'Limit reached | Upgrade' : remainingActions  + ' free AI action' + (remainingActions === 1 ? '' : 's')}}
            </div>
        </div>
       <div v-if="showPopover" class="popover">
            <div class="content-wrapper">
                <Icon :icon-name="'ai-sparkling-icon'" />
                <div class="text-wrapper">
                    <div class="title">Remaining: {{remainingActions}} actions</div>
                    <div class="subtitle">The Free plan includes 2 AI actions</div>
                </div>
            </div>
            <div class="upgrade-card-wrapper">
                <div class="text-wrapper">
                    <div class="title">Create without limits</div>
                    <div class="subtitle">Unlock unlimited actions</div>
                </div>
                <TertiaryButton @click="navigate" text="Upgrade" />
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "@/scripts/common/Icon.vue";
import TertiaryButton from "@/scripts/common/components/TertiaryButton.vue";
import MixpanelService from "@/scripts/analytics/mixpanel.js";
import {AiFeatures} from "@/scripts/common/enums.js";

export default {
    name: 'LimitTag',
    components: {
        TertiaryButton,
        Icon
    },
    props: {
        aiFeature: {
            type: String, // e.g. AiFeatures.CASE_STUDY_GENERATOR
            required: true,
        }
    },
    data() {
        return {
            showPopover: false,
        }
    },
    computed: {
        limitReached() {
            return !this.$store.getters.userHasAiToken(AiFeatures[this.aiFeature]);
        },
        remainingActions() {
            return this.$store.state.user.featureTokens[AiFeatures[this.aiFeature]];
        },
    },
    methods: {
        onMouseEnter() {
            if (this.popoverTimeout) {
                clearTimeout(this.popoverTimeout);
                this.popoverTimeout = null;
            }
            this.showPopover = true;
        },
        onMouseLeave() {
            this.popoverTimeout = setTimeout(() => {
                this.showPopover = false;
            }, 100);
        },
        navigate() {
            MixpanelService.track("UPGRADE_CTA_CLICKED",
                {
                    ...MixpanelService.getUrls(),
                    "event_group": MixpanelService.MixpanelEventGroups.USER_LIFECYCLE,
                    "source": this.aiFeature,
                    "context": `Editor - ${this.aiFeature}`,
                    "to": "Prices"
                }
            )

            this.$router.push("/home/prices");
        }
    }
}
</script>

<style scoped lang="scss">
    .limit-tag-container {
        position: relative;

        &:hover {
            .limit-tag {
                background: var(--asphalt80);
            }
        }

        .limit-tag {
            display: inline-flex;
            padding: 6px 10px 6px 6px;
            align-items: center;
            gap: 6px;
            border-radius: 4px;
            background: var(--asphalt90);
            backdrop-filter: blur(2px);
            color: var(--volt);
            font: var(--editor-ui-b2-regular);

            svg {
                width: 16px;
                height: 16px;
            }

            &:hover {
                cursor: pointer;
            }
        }

        .popover {
            display: flex;
            width: 340px;
            padding: 20px;
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
            border-radius: 6px;
            border: 1px solid var(--asphalt80);
            background: var(--asphalt90);
            position: absolute;
            top: 40px;
            right: 0;
            z-index: 10;

            .content-wrapper {
                display: flex;
                align-items: center;
                gap: 11px;
                align-self: stretch;

                svg {
                    width: 32px;
                    height: 32px;
                    aspect-ratio: 1/1;
                    color: var(--asphalt10);
                }

                .text-wrapper {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    flex: 1 0 0;

                    .title {
                        color: var(--asphalt15);
                        font: var(--editor-ui-b1-medium);
                    }

                    .subtitle {
                        color: var(--asphalt40);
                        font: var(--editor-ui-b3-regular);
                    }
                }
            }

            .upgrade-card-wrapper {
                display: flex;
                width: 301px;
                height: 70px;
                padding: 16px;
                justify-content: space-between;
                align-items: center;
                border-radius: 4px;
                background: var(--volt);

                .text-wrapper {
                    .title {
                        color: var(--asphalt100);
                        font: var(--editor-ui-b2-semibold);
                    }

                    .subtitle {
                        color: var(--asphalt80);
                        font: var(--editor-ui-b3-regular);
                    }
                }
            }
        }
    }
</style>
